import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext.jsx";
import { Splash } from "../components/Splash.jsx";

/* The gate in front of every route that shows data. While the first
   /auth/me is still in flight nothing is decided — rendering the sign-in
   page here would flash it at people who are already signed in. */
export function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Splash label="Checking your access" />;
  if (!user) {
    /* Where they were going, so sign-in can put them back there. */
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}

/* Managing who has access is administrators only. A member who follows a
   link to it is told so, rather than bounced to a page that looks broken. */
export function RequireAdmin() {
  const { user, loading } = useAuth();
  if (loading) return <Splash label="Checking your access" />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/denied" replace />;
  return <Outlet />;
}
